import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import SideBar from "../../components/SideBar/SideBar";
import NavBar1 from "../../components/Navbar1/NavBar1";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { string_to_slug } from "../../store/utility";
import SearchProducts from "../../components/SearchProducts/SearchProducts";
import Spinner from "../../components/Spinner/Spinner";
const Search = (props) => {
  let { searchKey, suggestion } = props.match.params;

  useEffect(() => {
    if (string_to_slug(searchKey) !== suggestion) {
      let sug = null;

      if (suggestion != "results") {
        //Incase enter rather than selecting any option then suggesstion becomes "results"

        sug = suggestion.replaceAll("-", " ");
      }

      props.getSearchProducts(searchKey, sug);
    }
  }, [searchKey, suggestion]);
  if (props.loading) {
    return <Spinner />;
  }
  return (
    <>
      <NavBar1 />
      <SideBar>
        <Footer>
          {React.cloneElement(<SearchProducts key={Math.random() * 10000} />)}
          {!props.leadsexhausted ? (
            <div
              style={{ width: "100%", textAlign: "center" }}
              className="mb-3"
            >
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  let { leadsexhausted, lastDoc, limit } = props;
                  props.loadMoreSearchProducts(
                    searchKey,
                    suggestion,
                    leadsexhausted,
                    lastDoc,
                    limit
                  );
                }}
                disabled={props.loadMore}
              >
                {props.loadMore ? "Loading" : "Load More"}
              </button>
            </div>
          ) : null}
        </Footer>
      </SideBar>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    leadsexhausted: state.homeProducts.leadsexhausted,
    limit: state.homeProducts.limit,
    lastDoc: state.homeProducts.lastDoc,
    loadMore: state.homeProducts.loadMore,
    loading: state.homeProducts.loading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSearchProducts: (searchKey, suggestion) =>
      dispatch(actions.fecthSearchProducts(searchKey, suggestion)),
    loadMoreSearchProducts: (
      searchKey,
      suggestion,
      leadsexhausted,
      lastDoc,
      limit
    ) =>
      dispatch(
        actions.loadMoreSearchProducts(
          searchKey,
          suggestion,
          leadsexhausted,
          lastDoc,
          limit
        )
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Search);
